import React, { useEffect, useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { adminEmailGet, adminEmailSave, adminEmailTestar } from '../../lib/api';

const EmailSection = () => {
  const [f, setF] = useState({ host: 'smtp.hostinger.com', porta: '465', usuario: '', senha: '', nome_remetente: "In'Nova Envios" });
  const [info, setInfo] = useState(null);
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    adminEmailGet().then((c) => { setInfo(c); setF((cur) => ({ ...cur, host: c.host, porta: String(c.porta), usuario: c.usuario, nome_remetente: c.nome_remetente })); });
  }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const salvar = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try {
      const c = await adminEmailSave({ host: f.host, porta: Number(f.porta), usuario: f.usuario, senha: f.senha || null, nome_remetente: f.nome_remetente });
      setInfo(c); setF({ ...f, senha: '' });
      setMsg({ ok: true, text: 'Salvo. Clique em "Enviar e-mail de teste" para conferir.' });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setMsg({ ok: false, text: typeof d === 'string' ? d : 'Confira os campos.' });
    } finally { setBusy(false); }
  };

  const testar = async () => {
    setBusy(true); setMsg(null);
    try { const r = await adminEmailTestar(); setMsg({ ok: true, text: `E-mail de teste enviado para ${r.para}.` }); }
    catch (err) { setMsg({ ok: false, text: err?.response?.data?.detail || 'Falha no teste.' }); }
    finally { setBusy(false); }
  };

  return (
    <section className="bg-white rounded-2xl border border-slate-100 p-6 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-900">E-mail (envio de etiquetas)</h2>
      <p className="text-sm text-slate-500 mb-1">Caixa usada para enviar as etiquetas por e-mail. Na Hostinger, use os dados da caixa de e-mail do seu domínio.</p>
      <p className={`text-sm font-medium mb-5 ${info?.configurado ? 'text-emerald-600' : 'text-amber-600'}`}>{info?.configurado ? 'Configurado.' : 'Ainda não configurado: o botão "Enviar por e-mail" fica indisponível até salvar.'}</p>
      <form onSubmit={salvar} className="space-y-4">
        <div className="grid sm:grid-cols-3 gap-4">
          <label className="block sm:col-span-2"><span className="text-sm font-medium text-slate-700">Servidor SMTP</span><Input className="mt-1" value={f.host} onChange={set('host')} required /></label>
          <label className="block"><span className="text-sm font-medium text-slate-700">Porta</span><Input className="mt-1" inputMode="numeric" value={f.porta} onChange={set('porta')} required /></label>
        </div>
        <label className="block"><span className="text-sm font-medium text-slate-700">E-mail (usuário)</span><Input className="mt-1" type="email" value={f.usuario} onChange={set('usuario')} placeholder="suporte@innovaenvios.app" required /></label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Senha da caixa de e-mail</span>
          <Input className="mt-1" type="password" autoComplete="new-password" value={f.senha} onChange={set('senha')} required={!info?.tem_senha} />
          <span className="block text-xs text-slate-500 mt-1">{info?.tem_senha ? 'Já salva. Deixe em branco para manter.' : 'É a senha criada para essa caixa no hPanel, não a do seu login da Hostinger.'}</span>
        </label>
        <label className="block"><span className="text-sm font-medium text-slate-700">Nome que aparece para quem recebe</span><Input className="mt-1" value={f.nome_remetente} onChange={set('nome_remetente')} maxLength={60} /></label>
        {msg && <p className={`text-sm ${msg.ok ? 'text-emerald-600' : 'text-red-600'}`}>{msg.text}</p>}
        <div className="flex gap-3">
          <Button type="submit" disabled={busy} className="inn-btn-primary rounded-full h-10 px-6">Salvar</Button>
          <Button type="button" variant="outline" disabled={busy || !info?.configurado} onClick={testar} className="rounded-full h-10 px-6">Enviar e-mail de teste</Button>
        </div>
      </form>
    </section>
  );
};

export default EmailSection;
